const API_BASE         = "https://api.firmconnector.com/index.php/";
const ASSETS_BASE      = "https://api.firmconnector.com/assets/";
const PROFILE_IMG_BASE = "https://api.firmconnector.com/";
const FIRM_IMG_BASE    = "https://api.firmconnector.com/";

export { API_BASE, ASSETS_BASE, PROFILE_IMG_BASE, FIRM_IMG_BASE };
